import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProductGroupPdpComparison } from '../../components/product-group-comparison/ProductGroupPdpComparison';
import { ProductGroupFredhopperActions } from '../../redux/productGroupFredhopper/actions/ProductGroupFredhopper.creators';
import { makeGetProductGroupFredhopper } from '../../redux/productGroupFredhopper/selectors/ProductGroupFredhopperSelectors';
const ProductGroupPdpComparisonFredhopperContainer = ({ campaign, productGroupFredhopperId, title, productsFeaturesRecord, currentProductHasFeatures }) => {
    const dispatch = useDispatch();
    const productGroupFredhopper = useSelector(makeGetProductGroupFredhopper());
    useEffect(() => {
        var _a;
        if (productGroupFredhopperId && ((_a = productGroupFredhopper === null || productGroupFredhopper === void 0 ? void 0 : productGroupFredhopper[productGroupFredhopperId]) === null || _a === void 0 ? void 0 : _a.length)) {
            dispatch(ProductGroupFredhopperActions.init());
        }
    }, []);
    const products = productGroupFredhopper === null || productGroupFredhopper === void 0 ? void 0 : productGroupFredhopper[productGroupFredhopperId];
    if (!(products === null || products === void 0 ? void 0 : products.length)) {
        return null;
    }
    return (_jsx(ProductGroupPdpComparison, { analyticsAreaName: "product-group-pdp-comparison-fredhopper", productGroupId: `product-group-pdp-comparison-fredhopper-${campaign}`, products: products, productsFeaturesRecord: productsFeaturesRecord, title: title, analyticsProductGroupName: `fh_${campaign}`, currentProductHasFeatures: currentProductHasFeatures, testId: "product-group-pdp-comparison-fredhopper", fredhopperCampaign: campaign }));
};
export default ProductGroupPdpComparisonFredhopperContainer;
